import { TableRow, TableCell } from '@material-ui/core'
import { withStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Colors } from './ColoredTableCell'
import styled from 'styled-components'

export const ContainerStyledTable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 82px;
`

export const DefaultTableCellToNested = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#2D4054',
      color: theme.palette.common.white
    },
    body: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      textAlign: 'left',
      '&.blue': {
        backgroundColor: '#9ED6EE'
      },
      '&.grey': {
        backgroundColor: '#B6B6B6',
        color: theme.palette.common.black
      },
      '&:first-child': {
        textAlign: 'left',
        minWidth: '280px',
        padding: '0 4px 0 16px',
        height: '82px'
      }
    }
  })
)(TableCell)

export const NestedColoredTableRow = withStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 5,
      fontSize: 12,
      border: 'none',
      borderRight: '1px solid #aaa8a8',
      textAlign: 'center',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      [`&.${Colors.red}`]: {
        width: 150,
        color: '#dc3e44',
        backgroundColor: '#FFADB1'
      },
      [`&.${Colors.green}`]: {
        width: 150,
        color: '#099461',
        backgroundColor: '#c7ebdb'
      },
      [`&.${Colors.blue}`]: {
        width: 150,
        color: '#1c4164',
        backgroundColor: '#9ED6EE'
      },
      '&.bold': {
        fontWeight: 'bold'
      }
    }
  })
)(TableRow)

export const NestedDefaultTableRow = withStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      fontSize: 10,
      border: 'none',
      textAlign: 'center',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
    }
  })
)(TableRow)
